export default __webpack_public_path__ + "static/media/banner-image-7.4518f31e.jpg";